/** Canonical pure type-guard predicates for the validation modules. */

/* This module declares BODIES only -- it re-exports nothing and aliases nothing. A predicate whose body lives in an
 * `@federa/const` pure leaf (`isPlainObject`, `isNonEmptyString`, `isPresentValue`, the errno pair) is imported from
 * that leaf, so each predicate has exactly ONE entry point and one spelling; a second one is the
 * `QUAL-NARROWING-HELPER-CLONE-001` class rather than a sanctioned alias.
 *
 * "It COMPOSES a const leaf rather than mirroring one" was recorded here as a reason a predicate MAY NOT move, and it
 * was wrong: composition is cheapest at the composed leaf. `isEmptyObject` moved to `const/record-guards.ts` beside the
 * `isPlainObject` it composes on 2026-08-13, because a pure `utils/` leaf may not value-import a `utils/` sibling and
 * `utils/data/null-if-empty.ts` had answered that ban by re-declaring the body privately -- one name, two
 * implementations. `isUuid` followed it to `const/regexes.ts` on 2026-08-20, beside the `UUID_REGEX` it composes: the
 * "composes DATA rather than a const predicate" carve recorded here did not survive a utils-layer CALLER
 * (`utils/property/property-slug.ts`), which the same import ban puts out of reach of a utils home. What survives here
 * is the set with genuinely no const home: `isNonNull` / `hasOwn` compose nothing at all. */

/** For `Array.filter`, which keeps TypeScript's narrowing through the predicate. */
export function isNonNull<T>(value: T | null | undefined): value is T {
	return value != null;
}

/** Prototype-pollution-safe own-property check. */
export function hasOwn(obj: object, key: PropertyKey): boolean {
	return Object.prototype.hasOwnProperty.call(obj, key);
}
